import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSupportUnreadCount = async () => {
  const token = localStorage.getItem("token");
  const { data } = await axios.get(`${__API_URL__}/api/support/admin/unread-count/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};

const useGetSupportUnreadCount = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["support-unread-count"],
    queryFn: fetchSupportUnreadCount,
    refetchInterval: 30000,
    enabled,
  });
};

export default useGetSupportUnreadCount;
